import React, { useState, useEffect } from 'react';
import { Icon, useBreakpoint } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ModuleWrapper } from '../../../Wrappers/ModuleWrapper';
import { getVideoIdYoutube } from '../../../../utils/index';
import {
  Subtitle,
  SectionContainer,
  ButtonsContainer,
  InputVideo,
  ErrorMessage,
  AddButton,
  VideoList,
  Video,
  VideoDetail,
  TrashIcon,
  ToggleVideo
} from './styles';
import {
  getVideos,
  addMultimedia,
  MultimediaType,
  MultimediaCollection,
  deleteMultimedia
} from '../../../../ducks/step2';

export const Videos = ({
  register,
  errors,
  trigger,
  setValue,
  getValues,
  emptyInputs,
  setEmptyInputs,
  setValidateVideo,
  validateVideo,
  clearErrors
}) => {
  const [collapse, setCollapse] = useState(false);
  const { videos } = useSelector(getVideos);
  const [reachedBreakPoint] = useBreakpoint(768);
  const { emptyVideo } = emptyInputs;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    const addVideo = () => {
      const videoUrl = getValues('videoUrl');
      const objVideo = {
        key_video: getVideoIdYoutube(videoUrl),
        multimediaType: MultimediaType.VIDEO
      };
      setValue('videoUrl', '');
      return objVideo.key_video && dispatch(addMultimedia(objVideo, MultimediaCollection.VIDEO));
    };

    const triggerAddVideo = async () => {
      const videoUrl = getValues('videoUrl');
      if (videoUrl === '' && !emptyVideo) {
        setEmptyInputs({ ...emptyInputs, emptyVideo: true });
      } else if (videoUrl !== '' && emptyVideo) {
        setEmptyInputs({ ...emptyInputs, emptyVideo: false });
      }
      const result = await trigger('videoUrl');
      if (result) {
        return addVideo();
      }
      if (!result && errors.videoUrl.type === 'maxArray') {
        return setValue('videoUrl', '');
      }
      return null;
    };
    if (validateVideo) {
      triggerAddVideo();
    }
    return setValidateVideo(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValidateVideo, validateVideo]);

  const deleteVideo = id => {
    return dispatch(deleteMultimedia(id, MultimediaCollection.VIDEO));
  };

  return (
    <ModuleWrapper title={t('publisher.step2.module3.video.title')}>
      <Subtitle data-repa='step2-video-subtitle'>{t('publisher.step2.module3.video.text')}</Subtitle>
      <SectionContainer data-repa='step2-video-sectionContainer'>
        <ButtonsContainer data-repa='step2-video-buttonContainer'>
          <InputVideo
            data-repa='step2-videos-input'
            className={errors.videoUrl && 'error'}
            type='text'
            disabled={videos.length === 10}
            name='videoUrl'
            ref={register}
            onKeyPress={evt => {
              if (evt.key === 'Enter') evt.preventDefault();
            }}
            placeholder={t('publisher.step2.module3.video.placeholder')}
            onFocus={() => clearErrors('videoUrl')}
          />
          <AddButton
            data-repa='step2-videos-button-add'
            type='button'
            disabled={videos.length === 10}
            onClick={() => {
              if (videos.length < 10) {
                setValidateVideo(true);
              }
            }}
          >
            {t('publisher.step2.module3.video.additionalVideo')}
          </AddButton>
          {errors.videoUrl && errors.videoUrl.type === 'matches' && (
            <ErrorMessage data-repa='step2-video-error-invalidUrl'>
              {t(`publisher.step2.module3.video.validation.invalidUrl.${reachedBreakPoint ? 'd' : 'm'}`)}
            </ErrorMessage>
          )}
          {errors.videoUrl && errors.videoUrl.type === 'existInArray' && (
            <ErrorMessage data-repa='step2-video-error-repeatUrl'>
              {t('publisher.step2.module3.video.validation.repeatUrl')}
            </ErrorMessage>
          )}
          {errors.videoUrl && errors.videoUrl.type === 'maxArray' && (
            <ErrorMessage notRed data-repa='step2-video-error-maxVideos'>
              {t('publisher.step2.module3.video.validation.maxVideos')}
            </ErrorMessage>
          )}
          {emptyVideo && (
            <ErrorMessage data-repa='step2-video-error-inputEmpty'>
              {t('publisher.step2.module3.video.validation.inputEmpty')}
            </ErrorMessage>
          )}
        </ButtonsContainer>
        <VideoList data-repa='step2-videos-itemlist' videos={videos.length} showing={collapse}>
          {videos.map(video => (
            <Video data-repa={`step2-videos-itemlist-item-${video.videoId}`} key={video.key_video}>
              <iframe
                data-repa={`step2-videos-itemlist-item-${video.videoId}-iframe`}
                title={video.videoId}
                width='100%'
                height='100%'
                src={`https://www.youtube-nocookie.com/embed/${video.key_video}`}
                frameBorder='0'
                allowFullScreen=''
              />
              <VideoDetail>
                <span>{`https://www.youtube.com/watch?v=${video.key_video}`}</span>
                <TrashIcon
                  data-repa={`step2-videos-itemlist-item-${video.videoId}-button-delete`}
                  onClick={() => deleteVideo(video.id)}
                />
              </VideoDetail>
            </Video>
          ))}
        </VideoList>
      </SectionContainer>
      {videos.length > 2 && (
        <ToggleVideo data-repa='step2-videos-collapseCheck' type='button' onClick={() => setCollapse(!collapse)}>
          <span data-repa='step2-video-collapseCheck-label'>
            {collapse ? t('publisher.step2.module2.video.btn.less') : t('publisher.step2.module2.video.btn.more')}
          </span>
          <Icon
            data-repa='step2-video-collapseCheck-label'
            name={collapse ? 'chevronUp' : 'chevronDown'}
            width={16}
            height={16}
            viewBox='0 0 16 16'
          />
        </ToggleVideo>
      )}
    </ModuleWrapper>
  );
};
